module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/covid_measures/1@2x_f84c54c3ff1f9268fa6c4ea4a73023a7.png";